import axios from "axios";
import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

const submitGuests = async (id, guests) => {
  const response = await axios.post(
    routes.inviteflowSubmitGuests(id),
    { guests },
    AXIOS_DEFAULT_CONFIG
  );
  return response;
};

export default submitGuests;
